export default __webpack_public_path__ + "static/media/insta3.c2493964.png";